import React from 'react'
import { Search } from 'lucide-react'

// ─────────────────────────────────────────────────────────────────────────────
// Form inputs , Input, Textarea, Select, SearchPill.
// All share the same chrome: hairline border, 9px radius, peach focus glow.
// ─────────────────────────────────────────────────────────────────────────────

const INPUT_BASE =
  'w-full px-3 py-2 bg-white border border-[#d6d3cb] rounded-[9px] text-[13px] text-[#1a1816] ' +
  'outline-0 transition-shadow placeholder:text-[#6b6862] ' +
  'focus:border-[#e85d1f] focus:shadow-[0_0_0_3px_rgba(232,93,31,.14)] ' +
  'disabled:bg-[#f5f4f0] disabled:text-[#9a968e] disabled:cursor-not-allowed'

const INPUT_BIG =
  'w-full px-3 py-2.5 bg-white border border-[#d6d3cb] rounded-[10px] text-[15px] font-medium ' +
  'text-[#1a1816] outline-0 transition-shadow placeholder:text-[#6b6862] placeholder:font-normal ' +
  'focus:border-[#e85d1f] focus:shadow-[0_0_0_3px_rgba(232,93,31,.14)]'

export const Input = React.forwardRef(function Input(
  { size = 'default', className = '', ...rest },
  ref,
) {
  const base = size === 'big' ? INPUT_BIG : INPUT_BASE
  return <input ref={ref} className={base + (className ? ' ' + className : '')} {...rest}/>
})

export const Textarea = React.forwardRef(function Textarea(
  { className = '', rows = 3, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      className={INPUT_BASE + ' resize-y' + (className ? ' ' + className : '')}
      {...rest}
    />
  )
})

// Native <select> with a custom chevron icon baked in via SVG background.
const SELECT_CHEVRON =
  'appearance-none bg-no-repeat bg-[right_10px_center] pr-9'
const SELECT_BG = "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 24 24' fill='none' stroke='%236b6862' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'></polyline></svg>\")"

export const Select = React.forwardRef(function Select(
  { className = '', children, ...rest },
  ref,
) {
  return (
    <select
      ref={ref}
      className={INPUT_BASE + ' ' + SELECT_CHEVRON + (className ? ' ' + className : '')}
      style={{ backgroundImage: SELECT_BG }}
      {...rest}
    >
      {children}
    </select>
  )
})

// SearchPill , icon + input bundled in a hairline pill. Use as a label.
export function SearchPill({
  value, onChange, placeholder = 'Suchen…', className = '', autoFocus,
}) {
  return (
    <label
      className={
        'inline-flex items-center gap-1.5 px-3 py-1.5 bg-white border border-[#e7e5df] rounded-[10px] ' +
        'w-full text-[#6b6862] focus-within:border-[#e85d1f] focus-within:shadow-[0_0_0_3px_rgba(232,93,31,.14)] ' +
        'transition-shadow ' +
        (className || '')
      }
    >
      <Search size={13} className="text-[#6b6862]" aria-hidden/>
      <input
        type="search"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoFocus={autoFocus}
        className="flex-1 min-w-0 bg-transparent border-0 outline-0 text-[13px] text-[#1a1816] placeholder:text-[#6b6862]"
      />
    </label>
  )
}
